import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/aica.svg";
import data from "../language.json";
import languageContext from "../context/language/languageContext";

const FrontPage = () => {
  const navigate = useNavigate();
  const { setLang } = useContext(languageContext);
  const currentPagePath = window.location.pathname;

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const handleLanguageChange = (event) => {
    const selectedLanguageIndex = event.target.value;
    if (selectedLanguageIndex !== "") {
      setLang(selectedLanguageIndex);
      localStorage.setItem("lang", selectedLanguageIndex);
      const loginBool = localStorage.getItem("login");
      if (loginBool === "true") {
        navigate("/warden-dashboard", { state: { url: currentPagePath } });
      } else {
        navigate("/login", { state: { url: currentPagePath } });
      }
    }
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-indigo-100 via-white to-blue-50 flex flex-col items-center justify-center px-4">
      {/* Logo Section */}
      <div className="flex flex-col items-center justify-center mb-10 animate-fadeIn">
        <img
          src={logo}
          alt="AICA Logo"
          className="w-32 sm:w-40 md:w-48 lg:w-56 drop-shadow-xl"
        />
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-blue-900 mt-6 text-center">
          Welcome, Warden
        </h1>
      </div>

      {/* Subtitle Section */}
      <p className="text-center text-lg sm:text-xl md:text-2xl text-gray-700 font-medium max-w-xl mb-8">
        Select your preferred language to continue managing student wellness with AICA
      </p>

      {/* Language Selector */}
      <div className="w-full max-w-sm">
        <select
          onChange={handleLanguageChange}
          className="appearance-none w-full px-5 py-3 border-2 border-blue-300 rounded-xl text-gray-800 shadow-md bg-white transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-400 hover:scale-105 cursor-pointer"
        >
          <option value="">Select Language</option>
          {data.map((language) => (
            <option key={language.index} value={language.index}>
              {capitalizeFirstLetter(language.name)}
            </option>
          ))}
        </select>
      </div>

      {/* Footer */}
      <div className="mt-12 text-sm text-gray-500 text-center">
        Powered by <span className="font-semibold text-blue-700">AICA</span> —
        Smart Health Assistant for Institutions
      </div>
    </div>
  );
};

export default FrontPage;
